import "./search.icon.scss"

export function SearchIcon() {
  return <img className="search-icon" src="/pictures/search-icon.png" alt="search-icon" />;
}
